// src/pages/Home/index.jsx
import React, { useState, useEffect } from 'react';
import { Layout, Row, Col, Typography, Spin, Empty, Alert } from 'antd';
import AppHeader from '../../components/header'; 
import AppFooter from '../../components/footer'; 
import PostCard from '../../components/PostCard'; 
import { getRecentPosts } from '../../api/mockData'; 
import './index.css';

const { Content } = Layout;
const { Title, Paragraph } = Typography;

const Home = ({ loggedInUser, onLogout }) => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [likedPosts, setLikedPosts] = useState(new Set());

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await getRecentPosts();
        setPosts(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  const handleLike = (postId) => {
    setLikedPosts(prev => {
      const newLikedPosts = new Set(prev);
      if (newLikedPosts.has(postId)) {
        newLikedPosts.delete(postId);
      } else {
        newLikedPosts.add(postId);
      }
      return newLikedPosts;
    });
  };

  const isLiked = (postId) => likedPosts.has(postId);

  return (
    <Layout className="blog-layout">
      <AppHeader onLogout={onLogout}/>
      
      <Content className="home-content">
        <div className="home-hero">
          <div className="hero-content">
            <Title level={1} className="hero-title">我的博客</Title>
            <Paragraph className="hero-subtitle">分享技术、生活与思考</Paragraph>
            {loggedInUser && (
              <Paragraph className="hero-hint">欢迎回来，{loggedInUser.username}！登录后即可编辑文章</Paragraph>
            )}
          </div>
        </div>

        <div className="home-container">
          <div className="home-section">
            <div className="section-header">
              <Title level={2} className="section-title">最新文章</Title>
              {loggedInUser && (
                <Paragraph className="section-hint">登录后即可编辑文章</Paragraph>
              )}
            </div>

            {loading ? (
              <div className="loading-container">
                <Spin size="large" />
              </div>
            ) : error ? (
              <Alert 
                message="加载失败" 
                description={error} 
                type="error" 
                showIcon 
              />
            ) : posts.length === 0 ? (
              <Empty 
                description="暂无文章" 
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            ) : (
              <Row gutter={[24, 24]} className="post-grid">
                {posts.map((post) => (
                  <Col span={24} md={12} key={post.id} className="post-col">
                    <PostCard 
                      post={post} 
                      onLike={handleLike} 
                      isLiked={isLiked(post.id)} 
                      loggedInUser={loggedInUser}
                    />
                  </Col>
                ))}
              </Row>
            )}
          </div>
        </div>
      </Content>
      
      <AppFooter />
    </Layout>
  );
};

export default Home;